import React from 'react';

/**
 * 升级提示弹窗组件（TailwindCSS 版）
 * @param props.visible 是否显示弹窗
 * @param props.onCancel 关闭弹窗回调
 * @param props.onUpgrade 点击升级回调
 */
export default function AlterModal({
  title,
  desc,
  visible,
  type,
  btnTitle,
  cancelBtnTitle,
  onCancel,
  onUpgrade,
}: {
  title: string;
  desc: string;
  visible: boolean;
  type?: boolean;
  btnTitle?: string;
  cancelBtnTitle?: string;
  onCancel: () => void;
  onUpgrade: () => void;
}) {
  if (!visible) return null;
  return (
    <div className="fixed inset-0 z-[3000] flex items-center justify-center">
      <div className="fixed inset-0 bg-black bg-opacity-70 transition-opacity" onClick={onCancel} />
      <div className="relative bg-white rounded-2xl shadow-xl w-[380px] max-w-[90vw] p-8 flex flex-col  animate-fade-in">
        <div className="text-xl text-left font-bold mb-3">{title}</div>
        <div className="text-black text-base mb-7 text-left">{desc}</div>
        {type ? (
          <div className="flex gap-3 w-full">
            <button
              className="flex-1 h-10 rounded-full border border-gray-300 font-medium text-gray-700 bg-white hover:bg-gray-100 transition"
              onClick={onCancel}
            >
              {cancelBtnTitle}
            </button>
            <button
              className="flex-1 h-10 rounded-full font-medium text-white bg-gradient-to-b from-[#7763FF] to-[#A29AFF] shadow"
              onClick={onUpgrade}
            >
              {btnTitle}
            </button>
          </div>
        ) : (
          <div className="flex gap-3 w-full">
            <button
              className="flex-1 h-10 rounded-full font-medium text-white bg-gradient-to-b from-[#7763FF] to-[#A29AFF] shadow"
              onClick={onUpgrade}
            >
              {btnTitle}
            </button>
          </div>
        )}
      </div>
      {/* 动画样式 */}
      <style>{`
        .animate-fade-in {
          animation: fadeInModal 0.18s cubic-bezier(.4,0,.2,1);
        }
        @keyframes fadeInModal {
          from { opacity: 0; transform: translateY(20px) scale(0.98); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
      `}</style>
    </div>
  );
}
